import React from 'react';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const FooterWrapper = styled('footer')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

const FooterText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  fontSize: '0.875rem',
  margin: 0,
}));

const FooterLinks = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  textDecoration: 'none',
  fontSize: '0.875rem',
  transition: theme.transitions.create(['color'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    color: theme.palette.secondary.light,
    textDecoration: 'underline',
  },
  '&:focus-visible': {
    outline: `3px solid #4a90e2`,
    outlineOffset: '2px',
    borderRadius: '4px',
  },
}));

function Footer() {
  return (
    <FooterWrapper>
      <FooterText>&copy; {new Date().getFullYear()} pray4all</FooterText>
      <FooterLinks>
        <FooterLink to="/privacy">Privacy Policy</FooterLink>
        <FooterLink to="/terms">Terms of Service</FooterLink>
      </FooterLinks>
    </FooterWrapper>
  );
}

export default Footer;